// extracted by mini-css-extract-plugin
export default {"container":"FloatButton_container__nDe1A","button":"FloatButton_button__VUjfV"};